export default { sha: 'b80027bf8a4bddd52c029899283df2bcb724f720', buildNumber: 'undefined' }
